var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "resportesserie" }, [
    _c(
      "div",
      { staticClass: "flex sm12 md12" },
      [
        _c(
          "FormFieldsContainer",
          [
            _c(
              "v-flex",
              {
                attrs: { sm12: "", md12: "", layout: "", wrap: "", "my-4": "" }
              },
              [
                _c(
                  "v-flex",
                  {
                    attrs: {
                      xs12: "",
                      sm10: "",
                      md8: "",
                      xxl6: "",
                      layout: "",
                      wrap: ""
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm4: "", md4: "" } },
                          [
                            _c("DatePicker", {
                              attrs: { label: "Fecha Inicio", max: _vm.now },
                              model: {
                                value: _vm.objParam.start_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.objParam, "start_date", $$v)
                                },
                                expression: "objParam.start_date"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { sm4: "", md4: "" } },
                          [
                            _c("DatePicker", {
                              attrs: { label: "Fecha Fin", max: _vm.now },
                              model: {
                                value: _vm.objParam.end_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.objParam, "end_date", $$v)
                                },
                                expression: "objParam.end_date"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.permiso == "Root"
                          ? _c(
                              "v-flex",
                              { attrs: { sm4: "", md4: "" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    label: "Usuario",
                                    items: _vm.usuariolist,
                                    "item-text": "username",
                                    "item-value": "id",
                                    clearable: "",
                                    "prepend-icon": "person"
                                  },
                                  on: { change: _vm.handleChange },
                                  model: {
                                    value: _vm.objParam.usuarioid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.objParam, "usuarioid", $$v)
                                    },
                                    expression: "objParam.usuarioid"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm4: "", md4: "" } },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            {
                                              attrs: {
                                                label: "Buscar...",
                                                "append-icon": "search",
                                                clearable: "",
                                                "prepend-icon": "info"
                                              },
                                              on: { input: _vm.handleChange },
                                              model: {
                                                value:
                                                  _vm.objParam.bdescripcion,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.objParam,
                                                    "bdescripcion",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "objParam.bdescripcion"
                                              }
                                            },
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "La búsqueda se realizará en las columnas Acción y\n                  Descripción"
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { sm4: "", md4: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Cliente",
                                items: _vm.clientelist,
                                "item-text": "nombre",
                                "item-value": "id",
                                clearable: "",
                                "prepend-icon": "home_repair_service"
                              },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.objParam.clienteid,
                                callback: function($$v) {
                                  _vm.$set(_vm.objParam, "clienteid", $$v)
                                },
                                expression: "objParam.clienteid"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { sm4: "", md4: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Módulo",
                                items: _vm.modulolist,
                                "item-text": "bmodulo",
                                "item-value": "bmodulo",
                                clearable: "",
                                "prepend-icon": "home_repair_service"
                              },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.objParam.bmodulo,
                                callback: function($$v) {
                                  _vm.$set(_vm.objParam, "bmodulo", $$v)
                                },
                                expression: "objParam.bmodulo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  {
                    attrs: {
                      xs12: "",
                      sm2: "",
                      md4: "",
                      xxl6: "",
                      layout: "",
                      wrap: "",
                      "mt-0": ""
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "", "ml-2": "" } },
                      [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleSearch } },
                              [
                                _c("v-icon", { attrs: { color: "#27488e" } }, [
                                  _vm._v("search")
                                ]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.reloadGrid({ clear: true })
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { color: "#27488e" } }, [
                                  _vm._v("clear")
                                ]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "gridcard rounded-card" },
      [
        _c("MantenedorGrid", {
          attrs: {
            "grid-options": _vm.gridOptions,
            funcionalidadId: _vm.funcionalidad
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }